import classNames from "classnames";
import { type FunctionComponent } from "react";
import { Link, type LinkProps } from "react-router-dom";

import { buttonClassNames, type ButtonProps } from "..";

import style from "./LinkButton.module.scss";

type ForwardedButtonProps = Omit<ButtonProps, keyof LinkProps>;

export interface LinkButtonProps extends LinkProps, ForwardedButtonProps {}

const LinkButton: FunctionComponent<LinkButtonProps> = ({
  children,
  size,
  fixedWidth,
  theme,
  className,
  ...linkProps
}) => (
  <Link
    {...linkProps}
    className={classNames(
      buttonClassNames({ size, fixedWidth, theme }),
      style.link,
      className
    )}
  >
    {children}
  </Link>
);

export default LinkButton;
